// /bundle == /all
// bundle is 100% simply prebundled version of /all
// use of this bundle should be discouraged!
// DEPRECATED: this whole file should be removed eventually!
export * from './index.js';

console.warn(`The bundles at @shui/core/shui/shui(.min).js will be moved soon.`);
console.warn(`Use this instead: @shui/core/bundle.`);
console.warn(`For best performance, consider using specific es imports instead: import '@shui/core/sh-button';`);
console.warn(`If you KNOW you need all components, use this: '@shui/core';`);

// this is ONLY for so the webpack var export stays backward compatible
// TODO: this should be removed ASAP
//   output: {
//     filename: mode === 'production' ? 'shui.min.js' : 'shui.js',
//     library: {
//         name: 'ShuiEnvironment',
//         type: 'var',
//     },
//   },
import { ShuiEnvironment as _legacyEnv } from './index.js';
export const ShuiEnvironmentLegacy = new Proxy(_legacyEnv, {
    get: function(target, prop) {
        console.warn(`Using the global ShuiEnvironment variable has been deprecated. It will be moved soon.`);
        console.warn(`Use this instead: import { ShuiEnvironment } from '@shui/core/environment';`);
        return target[prop];
    }
});

